import React, { FC } from 'react'
import classNames from 'classnames'

import StylesModule from 'components/lv3/topMessage.module.scss'
import { MessageProps } from 'message/index.props'

import AnimeArea from 'components/lv2/AnimeArea'
export interface TopMessageProps {
  message: MessageProps
}

const TopMessage: FC<TopMessageProps> = ({ message }) => {
  return (
    <section className={classNames(StylesModule.topMessage)}>
      <AnimeArea>
        <div className={classNames(StylesModule.topMessage__headWrap)}>
          <div className={classNames(StylesModule.topMessage__head)}>
            {message.top.message.headline}
          </div>
          <hr className={classNames(StylesModule.topMessage__borderTop)} />
        </div>
      </AnimeArea>
      <div
        className={classNames(
          StylesModule.topMessage__content,
          'mt-40',
          'mt-tb-64',
        )}
      >
        <AnimeArea>
          <h1 className={classNames(StylesModule.topMessage__title)}>
            {message.top.message.title}
          </h1>
        </AnimeArea>
      </div>
      <AnimeArea>
        <div
          className={classNames(StylesModule.topMessage__text, 'mt-40')}
          dangerouslySetInnerHTML={{
            __html: message.top.message.text,
          }}
        />
        <hr className={classNames(StylesModule.topMessage__borderBottom)} />
      </AnimeArea>
    </section>
  )
}

export default TopMessage
